import React from 'react';
import * as Yup from 'yup';

import Municipality from '../../../types/Municipality';
import City, { CityEditableFields } from '../../../types/City';

import handleApiErrors from '../../../lib/apiClient/handleErrors';
import updateCity from '../../../lib/apiClient/cities/update';
import deleteCity from '../../../lib/apiClient/cities/delete';

import InputCell from '../../common/ui/Table/Cells/InputCell';
import SearchCell from '../../common/ui/Table/Cells/SearchCell';
import Row from '../../common/ui/Table/Row';

interface Props {
  city: City;
  municipalities: Record<number, Municipality>;
  unauthorizedCallback: () => void;
  showError: (text: string) => void;
}

const CitiesTableRow = ({
  city: { id, name, municipalityId },
  municipalities,
  unauthorizedCallback,
  showError,
}: Props) => {
  const update = (city: CityEditableFields) =>
    handleApiErrors(updateCity(id, city), unauthorizedCallback, showError);

  const destroy = () =>
    handleApiErrors(deleteCity(id), unauthorizedCallback, showError);

  const municipalitiesNames = Object.values(municipalities).map(
    (municipality) => municipality.name,
  );
  const municipalitiesSelectOptions = Object.values(municipalities).map(
    (municipality) => ({
      id: municipality.id,
      label: municipality.name,
    }),
  );

  const nameValidationSchema = Yup.string().required(
    'Название города не может быть пустым',
  );

  const municipalityValidationSchema = Yup.string().oneOf(
    municipalitiesNames,
    'Указанного муниципалитета не существует',
  );

  return (
    <Row destroy={destroy}>
      <InputCell
        value={name}
        onConfirm={(value) => update({ name: value })}
        validationSchema={nameValidationSchema}
        onValidationFailure={(error) => showError(error)}
      />

      <SearchCell
        value={municipalities[municipalityId]?.name ?? ''}
        options={municipalitiesSelectOptions}
        onConfirm={(value) => update({ municipalityId: value })}
        validationSchema={municipalityValidationSchema}
        onValidationFailure={(error) => showError(error)}
      />
    </Row>
  );
};

export default CitiesTableRow;
